import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApisService } from 'app/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  styleUrls: ['./add-notification.component.scss']
})
export class AddNotificationComponent implements OnInit {
  entityForm: FormGroup;
  imagePreview: string | null = null;
  isDisabled: boolean = true;
  countries: string[] = ['United States', 'Canada', 'United Kingdom', 'Germany', 'France', 'UAE', 'Saudi Arabia', 'Egypt'];
  entityLevels: string[] = ['Level 1', 'Level 2', 'Level 3'];
  Roles = [
    { id: 1, title: 'ALL' },
    { id: 2, title: 'PLAYER' },
    { id: 3, title: 'COACH' },
    { id: 4, title: 'SCOUT' },
    { id: 5, title: 'OTHER' }
  ];
  dropdownOpen: boolean = false; // Controls dropdown visibility
  selectedTags: any[] = []; // Stores selected tags
  constructor(private fb: FormBuilder,
    private apisService: ApisService, 
    private toastr :ToastrService
  ) {
    this.entityForm = this.fb.group({
      title : this.fb.group({ 
        en : ['', [Validators.required, Validators.minLength(3)]],
        ar: ['', [Validators.required, Validators.minLength(3)]],
      }),
      subRole: this.fb.array([
        this.fb.control("FOOTBALL_FAN")
      ]),
      role: [null, [Validators.required]],
      body : this.fb.group({ 
        en : ['', [Validators.required, Validators.minLength(3)]],
        ar : ['', [Validators.required, Validators.minLength(3)]],
      })
    });
  }

  ngOnInit(): void {
    
  }
addNotification(data:any){ 
  this.apisService.sendNotification(data).subscribe({
    next: (data) => {
      console.log("Successfully added ", data );
      this.toastr.success("Notiication is successfully added")
      this.entityForm.reset()
    },
    error: (error) => {
      console.log("error ", error);
      this.toastr.error("Error in adding notification, Please Try again")
    },
  })
}


// submitting the form
  onSubmit() {
    if (this.entityForm.valid) {
      console.log('Form Data:', this.entityForm.value);
      console.log('Form Submitted Successfully');
      this.addNotification(this.entityForm.value);
    } else {
      console.log('Please fill all required fields');
    }
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

isSelected(tag: any): boolean {
  return this.selectedTags.some(t => t.id === tag.id);
}

toggleTag(tag: any) {
  if (tag.title === 'ALL') {
    if (this.isSelected(tag)) {
      // Unselect all
      this.selectedTags = [];
    } else {
      // Select all except 'ALL'
      this.selectedTags = this.Roles.filter(t => t.title !== 'ALL');
    }
  } else {
    const index = this.selectedTags.findIndex(t => t.id === tag.id);
    if (index === -1) {
      this.selectedTags.push(tag);
    } else {
      this.selectedTags.splice(index, 1);
    }

    // If user deselected any item, also deselect 'ALL'
    if (this.selectedTags.length < this.Roles.length - 1) {
      this.selectedTags = this.selectedTags.filter(t => t.title !== 'ALL');
    }

    // If all individual items are selected, mark 'ALL' as selected
    const allWithoutAll = this.Roles.filter(t => t.title !== 'ALL');
    if (this.selectedTags.length === allWithoutAll.length) {
      const allTag = this.Roles.find(t => t.title === 'ALL');
      if (allTag && !this.isSelected(allTag)) {
        this.selectedTags.push(allTag);
      }
    }
  }

  // Update form control
  this.entityForm.controls['role'].setValue(this.selectedTags.map(t => t.title));
}


  // Remove a tag from selection
  removeTag(tag: any) {
    this.selectedTags = this.selectedTags.filter(t => t.id !== tag.id);
    this.entityForm.controls['role'].setValue([...this.selectedTags.map(t => t.title)]);
  }

}
